import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiDelete, apiPost } from '@/shared/api'
import { toast } from '@/shared/ui/toast'
import { taskErrorText } from '../lib/error-text'
import { taskKeys } from './queries'

// Строка «когда напомнить» ровно одной природы: leadSeconds — за сколько до
// момента срока (0 = «в момент срока»), remindAt — календарный момент. Обе сразу
// или ни одной бэк отбивает 400: момент отправки должен быть однозначен.
export interface ReminderDraft {
  leadSeconds?: number
  remindAt?: string
}

function reminderBody(draft: ReminderDraft): Record<string, unknown> {
  return draft.leadSeconds === undefined
    ? { remind_at: draft.remindAt }
    : { lead_seconds: draft.leadSeconds }
}

// Набор напоминаний живёт в карточке (`GET /tasks/{id}` несёт reminders), потому
// обе мутации не оптимистичны: правим набор — перечитываем карточку.
export function useAddReminderMutation(taskId: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (draft: ReminderDraft) =>
      apiPost(`/tasks/${taskId}/reminders`, reminderBody(draft)),
    onError: (err) => toast.error(taskErrorText(err, 'Не удалось добавить напоминание')),
    onSettled: () => void qc.invalidateQueries({ queryKey: taskKeys.detail(taskId) }),
  })
}

export function useRemoveReminderMutation(taskId: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (reminderId: string) => apiDelete(`/tasks/${taskId}/reminders/${reminderId}`),
    onError: (err) => toast.error(taskErrorText(err, 'Не удалось снять напоминание')),
    onSettled: () => void qc.invalidateQueries({ queryKey: taskKeys.detail(taskId) }),
  })
}
